const initState = {
  currentParametersSchema: undefined,
  isOpenSnackbar: false,
  isFetching: false,
};

function parametersSchema(state = initState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return initState;
    case 'SET_PARAMETERS_SCHEMA':
      return { ...state, currentParametersSchema: action.currentParametersSchema };
    case 'TOGGLE_SNACKBAR':
      return { ...state, isOpenSnackbar: action.isOpenSnackbar };
    case 'TOGGLE_FETCHING':
      return { ...state, isFetching: action.isFetching };
    default:
      return state;
  }
}

export default parametersSchema;
